// ═══════════════════════════════════════════════════════════════════════════
// LIEN D'EMAIL MORT — lecture de l'échec renvoyé par Supabase (incident 04/08/2026)
//
// Supabase (GoTrue) renvoie l'échec d'un lien magique / de réinitialisation dans
// le HASH de l'URL, jamais en query :
//   https://app.aureussocial.be#error=access_denied&error_code=otp_expired&...
//
// Le hash n'atteint JAMAIS le serveur. Jusqu'ici AUCUN écran ne le lisait :
// l'utilisateur atterrissait sur la page commerciale publique (ou sur un
// « Vérification du lien... » infini), sans un mot d'explication. Il en concluait
// « je n'ai jamais reçu le mail » alors que le mail était bien arrivé — vérifié
// côté Resend : `delivered`. Son lien avait simplement déjà été consommé.
//
// Cause fréquente : les passerelles anti-spam d'entreprise OUVRENT les liens pour
// les analyser (SpamTitan chez itplace.com, Safe Links chez Microsoft…). Or le
// lien Supabase est un GET à USAGE UNIQUE : le premier qui l'ouvre le brûle.
// L'app ne peut pas empêcher ça — mais elle doit le DIRE, pas se taire.
//
// ⚠️ ET SURTOUT NE PAS RENVOYER VERS LA BOUCLE (02/09/2026). Le bouton s'appelait
// « Demander un nouveau lien » — c'est-à-dire précisément le geste qui (1) tue le
// lien précédent, (2) se fait brûler à son tour par le même filtre. Le contact de
// BD Motion a tourné ainsi pendant trois jours, alors que ses identifiants
// l'attendaient dans sa boîte. Pire : le bouton MENAIT DÉJÀ vers /login, donc son
// libellé décrivait une action qu'il ne faisait même pas. La sortie est le mot de
// passe, jamais un lien de plus.
// ═══════════════════════════════════════════════════════════════════════════

/**
 * @param {string} hash - window.location.hash
 * @returns {{code: string, expire: boolean} | null} null si le lien n'est pas en erreur
 */
export function lireErreurLienAuth(hash) {
  if (!hash || !hash.includes('error')) return null;
  const p = new URLSearchParams(String(hash).replace(/^#/, ''));
  const code = p.get('error_code') || p.get('error') || '';
  if (!code) return null;
  // otp_expired = expiré OU déjà ouvert : Supabase ne distingue pas les deux cas.
  return { code, expire: /otp_expired|expired/i.test(code) };
}

// R8 — FR + NL (plus d'EN/DE depuis le 11/07/2026).
export const TXT_LIEN_MORT = {
  fr: {
    titre: 'Ce lien n’est plus valable',
    corps: 'Il a expiré, ou il a déjà été ouvert une fois : certains filtres de sécurité ouvrent les liens automatiquement avant vous. Inutile d’en redemander un — le suivant subira le même sort. Connectez-vous plutôt avec le mot de passe qui vous a été envoyé par e-mail (message « Vos identifiants Aureus Social Pro ») : il n’expire pas. Si vous ne l’avez pas, demandez-le à votre administrateur.',
    bouton: 'Aller à la page de connexion',
    attente: 'Le lien n’a pas pu être vérifié. Il est peut-être expiré ou déjà ouvert.',
  },
  nl: {
    titre: 'Deze link is niet meer geldig',
    corps: 'Hij is verlopen of al één keer geopend: sommige beveiligingsfilters openen links automatisch vóór u. Een nieuwe aanvragen heeft geen zin — die zal hetzelfde lot ondergaan. Meld u aan met het wachtwoord dat u per e-mail hebt ontvangen (bericht « Uw inloggegevens voor Aureus Social Pro ») : dat verloopt niet. Hebt u het niet, vraag het dan aan uw beheerder.',
    bouton: 'Naar de aanmeldpagina',
    attente: 'De link kon niet worden geverifieerd. Hij is mogelijk verlopen of al geopend.',
  },
};

/** Langue du visiteur, sans dépendance : FR par défaut, NL si le navigateur est NL. */
export function langueLienMort() {
  const l = (typeof navigator !== 'undefined' && navigator.language) || '';
  return /^nl/i.test(l) ? 'nl' : 'fr';
}
